export const regTabNames = {
  PROTOCOL_INFORMATION: "Protocol Information",
  REGULATORY_SETUP: "Regulatory Setup",
  SIGNOFF_SUBMITTED: "Signoff: Submitted",
  SIGNOFF_IN_PROGRESS: "Signoff: In Progress",
  SIGNOFF_COMPLETED: "Signoff: Completed"
};
